import { axiosInstance } from "@time-theft-analyzer/shared";

/**
 * Per-user MCP access key API (IAS-69 frontend, wired to IAS-68 backend).
 *
 * Each user manages only their OWN key. The raw key is returned exactly ONCE by `create`
 * and is never persisted server-side after that — the UI must never store it beyond the
 * single reveal. `getStatus` returns non-secret metadata only.
 */

export interface McpKeyStatus {
  success: boolean;
  exists: boolean;
  prefix: string | null;
  createdAt: string | null;
  expiresAt: string | null;
  lastUsedAt: string | null;
}

export interface McpKeyCreateResponse {
  success: boolean;
  /** The raw access key — shown exactly once. */
  accessKey: string;
  prefix: string;
  createdAt: string;
  expiresAt: string | null;
  message: string;
}

export interface McpKeyDeleteResponse {
  success: boolean;
  message: string;
}

/**
 * Create / regenerate the caller's MCP access key.
 * Pass either an ISO `expiresAt` date, or `{ noExpiry: true }`.
 */
export type McpKeyCreatePayload =
  | { expiresAt: string; noExpiry?: false }
  | { noExpiry: true; expiresAt?: undefined };

export const mcpKeyApi = {
  getStatus: () => axiosInstance.get<McpKeyStatus>("/api/mcp-key"),

  create: (payload: McpKeyCreatePayload) =>
    axiosInstance.post<McpKeyCreateResponse>("/api/mcp-key", payload),

  revoke: () => axiosInstance.delete<McpKeyDeleteResponse>("/api/mcp-key"),
};
